var map = {
	"./home_business_0.png": "4878",
	"./home_business_1.png": "05a0",
	"./home_business_2.png": "e76d",
	"./home_business_3.png": "9d05",
	"./home_business_bg.png": "809d",
	"./home_business_eng.png": "dadc",
	"./home_business_txt.png": "60e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6c4";